import { RestAPI } from "@/constants/routeAPI";

import axiosMethods from "./apiManager";

// eslint-disable-next-line import/prefer-default-export
export const postUIErrorReport = (error, errorInfo) => {
  const data = {
    errorMessage: JSON.stringify(error.message),
    errorInfo: JSON.stringify(error?.stack),
    componentStack: JSON.stringify(
      errorInfo?.componentStack || error?.componentStack
    ),
  };
  axiosMethods.post(RestAPI.UI_ERROR_REPORT, data);
};

export const getStatus = async (isCatchHandled = false) => {
  const response = await axiosMethods.get(
    RestAPI.STATUS,
    null,
    true,
    isCatchHandled
  );
  return response;
};

export const getConfiguration = async (isCatchHandled = false) => {
  const response = await axiosMethods.get(
    RestAPI.CONFIGURATION,
    null,
    true,
    isCatchHandled
  );
  return response;
};

export const getCycleParamDevice = async (isCatchHandled = false) => {
  const response = await axiosMethods.get(
    RestAPI.CYCLE_PARAM_DEVICE,
    null,
    true,
    isCatchHandled
  );
  return response;
};

export const postStartSeqDesignerDevice = async (data) => {
  const response = await axiosMethods.post(
    RestAPI.START_SEQUENCE_DESIGNER_DEVICE,
    data
  );
  return response;
};

export const postPauseSeqDesignerDevice = async () => {
  const response = await axiosMethods.post(
    RestAPI.PAUSE_SEQUENCE_DESIGNER_DEVICE
  );
  return response;
};

export const postResumeSeqDesignerDevice = async () => {
  const response = await axiosMethods.post(
    RestAPI.RESUME_SEQUENCE_DESIGNER_DEVICE
  );
  return response;
};

export const postStopSeqDesignerDevice = async () => {
  const response = await axiosMethods.post(
    RestAPI.STOP_SEQUENCE_DESIGNER_DEVICE
  );
  return response;
};

export const postSaveSeqDesignerDevice = async (
  repeat,
  operations,
  fileName,
  isSaveAs
) => {
  const data = {
    Repeat: repeat,
    Operations: operations,
    FileName: fileName,
    IsSaveAs: isSaveAs,
  };
  const response = await axiosMethods.post(
    RestAPI.SAVE_SEQUENCE_DESIGNER_DEVICE,
    data,
    null,
    true,
    true
  );
  return response;
};

export const getDetailSequence = async (fileName) => {
  const data = {
    fileName,
  };
  const response = await axiosMethods.post(RestAPI.GET_DETAIL_SEQUENCE, data);
  return response;
};

export const getListManualProfiles = async () => {
  const response = await axiosMethods.get(RestAPI.OPERATIONS_MANUAL_PROFILES);
  return response;
};

export const setFavoriteSequence = async (data) => {
  const response = await axiosMethods.post(RestAPI.SET_FAVORITE_SEQUENCE, data);
  return response;
};
